module.exports = __webpack_public_path__ + "static/media/QA.cd425cd0.png";